<template>
  <div class="clues-add">
    <el-dialog class="record-add" title="新增回款" width="1300px" :visible.sync="showAdd" :modal-append-to-body="false"
      @close="close">
      <el-form :inline="true"  v-if="showAdd" :model="returnMoney" ref="ruleForm" label-width="140px" label-position="right" :rules="rules">
        <el-form-item label="客户" prop="customer_name">
          <el-input :value="returnMoney.customer_name" readonly placeholder="请选择客户" style="width: 80%" clearable
            @click.native="setCustomer"></el-input>
        </el-form-item>
        <el-form-item label="合同" prop="contract_name">
          <el-input :value="returnMoney.contract_name" readonly placeholder="请选择合同" style="width: 80%" clearable
            @click.native="setContract"></el-input>
        </el-form-item>
        <el-form-item label="回款计划" @click="setPlan">
          <el-input :value="returnMoney.plan_name" placeholder="请选择回款计划" style="width: 80%" clearable
            @click.native="setPlan"></el-input>
        </el-form-item>
        <!-- 选完回款计划不可再选择回款金额 -->
        <el-form-item label="回款金额" prop="money">
          <el-input @blur="getValueData" min="0"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
            v-model="returnMoney.money" type="number" placeholder="请输入回款金额" style="width: 80%" clearable
            :disabled="Boolean(returnMoney.plan_id)"></el-input>
        </el-form-item>
        <el-form-item label="回款编号">
          <el-input v-model="returnMoney.number" placeholder="请输入回款编号" style="width: 80%" clearable></el-input>
        </el-form-item>
        <el-form-item label="回款方式" prop="return_type">
          <el-input v-model="returnMoney.return_type" placeholder="请输入回款方式" style="width: 80%" clearable></el-input>
        </el-form-item>
        <el-form-item label="回款日期" prop="return_time">
          <el-date-picker style="width: 80%" v-model="returnMoney.return_time" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input style="width: 80%" v-model="returnMoney.remark" placeholder="请输入备注" clearable></el-input>
        </el-form-item>
        <el-form-item class="submit" label-width="0"> </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <form-create v-model="yulanform" :rule="formrule" :option="option" @on-submit="onSubmit1"
        style="width: 100%;margin-top: 40px;"></form-create>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="lockAdd" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
    <mail-list ref="drawer" :module="module" :userid="this.$store.state.user.token.userid" :params="returnMoney"
      @handleSelect="handleSelect"></mail-list>
  </div>
</template>
<script>
import mailList from '@/components/drawer/mailList';
import { addReceivables } from "@/api/returnMoney.js";
export default {
  name: "returnMoneyAdd",
  inject: ["reload"],
  components: {
    mailList
  },
  data() {
    var checkMoney = (rule, value, callback) => {
      if (value < 1) {
        callback(new Error("金额必须大于0"));
      } else {
        callback();
      }
    };
    return {
      showAdd: false,
      id: 0,
      module: "",
      rules: {
        customer_name: [
          { required: true, message: "请选择客户", trigger: ['blur','change'] },
        ],
        contract_name: [
          { required: true, message: "请选择合同", trigger: ['blur','change']},
        ],
        money: [{ required: true, validator: checkMoney, trigger: ['blur','change'] }],
        return_type: [
          { required: true, message: "请输入回款方式", trigger: ['blur','change']},
        ],
        return_time: [
          { required: true, message: "请选择回款时间", trigger: ['blur','change']},
        ]
      },
      returnMoney: {
        plan_id: "",
        plan_name: "",
        number: "",
        customer_id: "",
        customer_name: "",
        contract_id: "",
        contract_name: "",
        return_time: "",
        return_type: "",
        money: "",
        remark: "",
      },
      lockAdd: false,
      yulanform: "",
      formrule: [],
      option: {
        submitBtn: {
          show: false,
        },
      },
      fie: [],
      custom_field: {},
      numMoney: 0,
    };
  },
  methods: {
    async onSave() {
      let selfSub = {}
      for (let i in this.custom_field) {
        this.fie.push(i)
      }
      for (let i = 0; i < this.fie.length; i++) {
        for (let j = 0; j < this.formrule.length; j++) {
          if (this.formrule[j].field == this.fie[i]) {
            this.$set(selfSub, this.fie[i], this.formrule[j])
          }
        }
      }
      const returnMoney = {
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        plan_id: this.returnMoney.plan_id,
        number: this.returnMoney.number,
        customer_id: this.returnMoney.customer_id,
        contract_id: this.returnMoney.contract_id,
        return_time: Number.parseInt(this.returnMoney.return_time.getTime() / 1000),
        return_type: this.returnMoney.return_type,
        money: this.returnMoney.money,
        remark: this.returnMoney.remark,
        self_content: JSON.stringify(selfSub)
      };
      this.lockAdd = true;
      const res = await addReceivables(returnMoney);
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.reload();
      }
      this.lockAdd = false;
    },
    handleSelect(person) {
      if (this.module === "customerList") {
        this.$set(this.returnMoney, "plan_id", "");
        this.$set(this.returnMoney, "plan_name", "");
        this.$set(this.returnMoney, "number", "");
        this.$set(this.returnMoney, "contract_id", "");
        this.$set(this.returnMoney, "contract_name", "");
        this.$set(this.returnMoney, "return_time", "");
        this.$set(this.returnMoney, "money", "");
        this.$set(this.returnMoney, "remark", "");

        this.$set(this.returnMoney, "customer_name", person.name);
        this.$set(this.returnMoney, "customer_id", person.id);
        this.id = person.id;
      }
      if (this.module === "contractList") {
        this.$set(this.returnMoney, "plan_id", "");
        this.$set(this.returnMoney, "plan_name", "");
        this.$set(this.returnMoney, "number", "");
        this.$set(this.returnMoney, "return_time", "");
        this.$set(this.returnMoney, "money", "");
        this.$set(this.returnMoney, "remark", "");

        this.$set(this.returnMoney, "contract_name", person.name);
        this.$set(this.returnMoney, "contract_id", person.id);
        this.id = person.id;
      }
      if (this.module === "getReceivablesPlanByContract") {
        this.$set(this.returnMoney, "plan_name", person.name);
        this.$set(this.returnMoney, "plan_id", person.id);
        this.$set(this.returnMoney, "number", person.num);
        this.$set(this.returnMoney, "return_type", person.return_type);
        this.$set(this.returnMoney, "money", person.money);
      }
    },
    setCustomer() {
      this.module = "customerList";
      this.$refs.drawer.open();
    },
    setContract() {
      if (!this.returnMoney.customer_id) {
        this.$message({
          message: "请先选择客户",
          type: "warning",
        });
        return;
      }
      this.module = "contractList";
      this.$refs.drawer.open();
    }, 
    setPlan() {
      if (!this.returnMoney.contract_id) {
        this.$message({
          message: "请先选择合同",
          type: "warning",
        });
        return;
      }
      this.module = "getReceivablesPlanByContract";
      this.$refs.drawer.open();
    },
    open() {
      this.showAdd = true;
      this.initData();
      this.getField();
    },
    close() {
      this.showAdd = false;
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.onSave();
          return true;
        } else {
          return false;
        }
      });
    },
    initData() {
      this.returnMoney = {
        plan_id: "",
        plan_name: "",
        number: "",
        customer_id: "",
        contract_id: "",
        return_time: "",
        return_type: "",
        money: "",
        remark: "",
      };
    },
    async getField() {
      const res = await this.axios({
        url: "/crm/ApplyExpense/get_custom_filed",
        method: "POST",
        data: {
          account_id: this.$store.state.user.token.account_id,
          state: "receivables"
        }
      })
      if (res.code == 1) {
        this.custom_field = res.data.custom_field
        let arr = []
        this.formrule = []
        for (let i in this.custom_field) {
          arr.push(this.custom_field[i])
        }
        arr.forEach(item => {
          if (!item.if_show) {
            item.display = item.if_show
          }
          this.formrule = arr;
        })
      }
    },
    onSubmit1(formData) {
      alert(JSON.stringify(formData));
    },
    /*只允许金额为数字*/
    getValueData() {
      if (this.numMoney) {
        let a = this.numMoney.substring(0, 1);
        let b = this.numMoney.substring(1, 2);
        if (a == '0' && b != '.') {
          this.numMoney = this.numMoney.slice(1);
        }
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.submit {
  margin-top: 60px;
  display: flex;
  justify-content: center;
}
::v-deep .form-create .el-input-item__content>.el-input,

.el-dialog .el-select,
 .el-dialog .el-input{
  width:470px !important;
}
::v-deep .el-col-24 {
    width: 50%;
}
</style>